import axios from '@axios';
import HelperService from '@/services/HelperService';
let helperService = new HelperService();

const base = '/api/v1/offsite-establishments';

export default {
  getOfflineEstablishments() {
    return axios.get(`${base}`);
  },
  getPaginated(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}${queryString}`);
  },
};
